var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-official': _vm.isOfficial, 'is-admin': _vm.isAdmin },attrs:{"id":"app"}},[(!_vm.isOfficial && !_vm.isAdmin)?_c('el-backtop',{attrs:{"bottom":60}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }